/*
 * Wijn.com winkelwagen: bezorgbelofte, "Frank tipt erbij", 18+-vinkje en de
 * meeschuivende afrekenbalk op mobiel. Wordt statisch geladen vanuit de header,
 * omdat scripts in de door het thema vernieuwde winkelwagen-HTML niet meer draaien.
 */
(() => {
  if (window.__wcWinkelwagen) return;
  window.__wcWinkelwagen = true;

  /* ---------- Bezorgbelofte: voor 16:00 besteld, vandaag verzonden ---------- */

  // Geen verzending in het weekend en op deze feestdagen (Nederland).
  const FEESTDAGEN = [
    '2026-12-25', '2026-12-26', '2027-01-01', '2027-03-28', '2027-03-29',
    '2027-04-27', '2027-05-05', '2027-05-06', '2027-05-16', '2027-05-17',
    '2027-12-25', '2027-12-26',
  ];
  const DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function nuInAmsterdam() {
    const delen = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date());
    const w = Object.fromEntries(delen.map((d) => [d.type, d.value]));
    return { datum: `${w.year}-${w.month}-${w.day}`, uur: +w.hour, minuut: +w.minute };
  }

  function isVerzenddag(datum) {
    const d = new Date(`${datum}T12:00:00Z`);
    const dag = d.getUTCDay();
    // Maandag t/m zaterdag verzenden (baas 30-9-2026); zondag en feestdagen niet.
    return dag !== 0 && !FEESTDAGEN.includes(datum);
  }

  function volgendeVerzenddag(datum) {
    const d = new Date(`${datum}T12:00:00Z`);
    for (let i = 0; i < 10; i++) {
      d.setUTCDate(d.getUTCDate() + 1);
      const s = d.toISOString().slice(0, 10);
      if (isVerzenddag(s)) return { datum: s, dag: d.getUTCDay(), stappen: i + 1 };
    }
    return null;
  }

  function beloftetekst() {
    const nu = nuInAmsterdam();
    const minutenTot16 = 16 * 60 - (nu.uur * 60 + nu.minuut);
    if (isVerzenddag(nu.datum) && minutenTot16 > 0) {
      // Aftellen alleen in de laatste drie uur; daarvoor de vaste belofte.
      if (minutenTot16 > 180) return { tekst: 'Voor 16:00 besteld, vandaag verzonden', vandaag: true };
      const u = Math.floor(minutenTot16 / 60);
      const m = minutenTot16 % 60;
      const tijd = u > 0 ? `${u} uur ${m} min` : `${m} min`;
      return { tekst: `Binnen ${tijd} besteld, vandaag verzonden`, vandaag: true };
    }
    const volgende = volgendeVerzenddag(nu.datum);
    if (!volgende) return { tekst: 'Voor 16:00 besteld, vandaag verzonden', vandaag: false };
    const wanneer = volgende.stappen === 1 ? 'morgen' : DAGEN[volgende.dag];
    return { tekst: `Nu besteld, ${wanneer} verzonden`, vandaag: false };
  }

  function zetBelofte() {
    const b = beloftetekst();
    document.querySelectorAll('[data-wc-belofte]').forEach((el) => {
      const t = el.querySelector('[data-wc-belofte-tekst]');
      if (t && t.textContent !== b.tekst) t.textContent = b.tekst;
      el.classList.toggle('wc-belofte--vandaag', b.vandaag);
    });
  }

  /* ---------- 18+: verplicht vinkje, bij elke bestelling opnieuw ---------- */

  // 29-9-2026: de NVWA eist bij elke aankoop een leeftijdscontrole, ook als de bezoeker cookies
  // gebruikt. Het vinkje wordt daarom niet meer een jaar in een cookie onthouden, alleen zolang
  // deze pagina openstaat (de lade wordt bij elke wijziging opnieuw opgebouwd). De oude cookie
  // wordt gewist. De snelle betaalknoppen (Shop Pay, PayPal, Google Pay) staan uit tot het vinkje aan staat.
  document.cookie = 'age_verified=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  let leeftijdBevestigd = false;
  // Lade en winkelwagenpagina kunnen allebei een vinkje hebben; die lopen altijd gelijk.
  const vinkjes = () => document.querySelectorAll('#age-verification, .wc-leeftijd__vinkje');
  const leeftijdGecheckt = () => (vinkjes().length ? leeftijdBevestigd : true);

  function herstelVinkje() {
    vinkjes().forEach((v) => {
      if (v.checked !== leeftijdBevestigd) v.checked = leeftijdBevestigd;
    });
    werkSnelleKnoppenBij();
  }

  function werkSnelleKnoppenBij() {
    const dicht = !leeftijdGecheckt();
    document.querySelectorAll('.wc-snel').forEach((blok) => {
      const knoppen = blok.querySelector('.wc-snel__knoppen');
      if (!knoppen) return;
      let slot = blok.querySelector('.wc-snel__slot');
      if (dicht && !slot) {
        slot = document.createElement('button');
        slot.type = 'button';
        slot.className = 'wc-snel__slot';
        slot.setAttribute('aria-label', 'Direct betalen: vink eerst aan dat je 18 jaar of ouder bent');
        blok.appendChild(slot);
      }
      if (slot) slot.hidden = !dicht;
      if (knoppen.hasAttribute('inert') !== dicht) knoppen.toggleAttribute('inert', dicht);
      blok.classList.toggle('wc-snel--dicht', dicht);
    });
  }

  function toonLeeftijdMelding(bron) {
    const kassa = bron && bron.closest ? bron.closest('.wc-kassa') : null;
    const melding = (kassa && kassa.querySelector('.wc-leeftijd__melding')) || document.getElementById('age-verification-message');
    if (!melding) return;
    melding.hidden = false;
    const blok = melding.closest('.wc-leeftijd');
    if (blok) {
      blok.classList.remove('wc-leeftijd--fout');
      void blok.offsetWidth;
      blok.classList.add('wc-leeftijd--fout');
    }
    melding.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // REACH's cart-summary zet dezelfde controle; die telt dan maar één keer.
  window.__ageVerificationInitialized = true;

  document.addEventListener('click', (e) => {
    const knop = e.target.closest('#checkout, .cart__checkout-button, .wc-snel__slot');
    if (!knop || leeftijdGecheckt()) return;
    e.preventDefault();
    e.stopPropagation();
    toonLeeftijdMelding(knop);
  }, true);

  document.addEventListener('submit', (e) => {
    if (!e.target || e.target.id !== 'cart-form' || leeftijdGecheckt()) return;
    e.preventDefault();
    e.stopPropagation();
    toonLeeftijdMelding(e.submitter || document.querySelector('.cart-page #checkout'));
  }, true);

  document.addEventListener('change', (e) => {
    const v = e.target;
    if (!v || !v.matches || !v.matches('#age-verification, .wc-leeftijd__vinkje')) return;
    leeftijdBevestigd = v.checked;
    herstelVinkje();
    if (leeftijdBevestigd) {
      document.querySelectorAll('.wc-leeftijd__melding, #age-verification-message').forEach((m) => { m.hidden = true; });
      document.querySelectorAll('.wc-leeftijd--fout').forEach((b) => b.classList.remove('wc-leeftijd--fout'));
    }
  });

  /* ---------- Toevoegen vanuit de winkelwagen (Franks tip, wenskaartje) ---------- */

  async function voegToe(bron, variant, eigenschappen) {
    const houder = bron.closest('cart-items-component');
    const sectie = houder?.dataset.sectionId;
    const root = window.Shopify?.routes?.root || '/';
    const item = { id: Number(variant), quantity: 1 };
    if (eigenschappen) item.properties = eigenschappen;
    const antwoord = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        ...(sectie ? { sections: sectie, sections_url: window.location.pathname } : {}),
      }),
    });
    const data = await antwoord.json();
    if (!antwoord.ok) throw new Error(data.description || data.message || 'Toevoegen mislukt');
    const wagen = await fetch(`${root}cart.js`).then((r) => r.json());
    const event = new Event('cart:update', { bubbles: true });
    event.detail = {
      resource: wagen,
      sourceId: 'wc-tip',
      data: { source: 'wc-tip', itemCount: wagen.item_count, variantId: String(variant), sections: data.sections || undefined },
    };
    document.dispatchEvent(event);
  }

  document.addEventListener('click', async (e) => {
    const knop = e.target.closest('[data-wc-erbij]');
    if (!knop || knop.disabled) return;
    e.preventDefault();
    knop.disabled = true;
    knop.classList.add('is-bezig');
    try {
      await voegToe(knop, knop.dataset.wcErbij);
    } catch (fout) {
      knop.disabled = false;
      knop.classList.remove('is-bezig');
      console.warn('[wijncom] tip toevoegen:', fout);
    }
  });

  // Wenskaartje: tekst verplicht, als regeleigenschap "Boodschap" mee.
  document.addEventListener('submit', async (e) => {
    const formulier = e.target.closest('[data-wc-kaartje]');
    if (!formulier) return;
    e.preventDefault();
    e.stopPropagation();
    const veld = formulier.querySelector('textarea');
    const fout = formulier.querySelector('[data-wc-kaartje-fout]');
    const knop = formulier.querySelector('button[type="submit"]');
    const tekst = veld.value.trim();
    if (!tekst) {
      fout.textContent = 'Schrijf eerst je boodschap.';
      fout.hidden = false;
      veld.focus();
      return;
    }
    fout.hidden = true;
    knop.disabled = true;
    knop.classList.add('is-bezig');
    try {
      await voegToe(formulier, formulier.dataset.wcKaartje, { Boodschap: tekst });
    } catch (err) {
      fout.textContent = 'Het kaartje kon niet worden toegevoegd. Probeer het nog eens.';
      fout.hidden = false;
      knop.disabled = false;
      knop.classList.remove('is-bezig');
      console.warn('[wijncom] kaartje toevoegen:', err);
    }
  }, true);

  document.addEventListener('input', (e) => {
    const veld = e.target.closest('[data-wc-kaartje] textarea');
    if (!veld) return;
    const teller = veld.form?.querySelector('[data-wc-teller]');
    if (teller) teller.textContent = `${veld.value.length} / ${veld.maxLength}`;
  });

  /* ---------- Net toegevoegd: de regel licht kort op ---------- */

  const TOEVOEG_BRONNEN = ['product-form-component', 'instant-add-buttons-component', 'wc-tip'];

  document.addEventListener('cart:update', (e) => {
    const d = e.detail;
    if (!d || d.data?.didError || !TOEVOEG_BRONNEN.includes(d.data?.source)) return;
    let variant = d.sourceId;
    if (d.data.source === 'wc-tip') variant = d.data.variantId;
    if (!variant) return;
    setTimeout(() => {
      document.querySelectorAll(`.cart-items__table-row[data-key^="${variant}:"]`).forEach((rij) => {
        rij.classList.remove('wc-net-toegevoegd');
        void rij.offsetWidth;
        rij.classList.add('wc-net-toegevoegd');
      });
    }, 250);
  });

  /* ---------- Mobiel: afrekenbalk die meeschuift op de winkelwagenpagina ---------- */

  let balk = null;
  let waarnemer = null;

  function bouwBalk() {
    if (!document.querySelector('.cart-page .wc-kassa') || balk) return;
    balk = document.createElement('div');
    balk.className = 'wc-balk';
    balk.setAttribute('aria-hidden', 'true');
    balk.innerHTML =
      '<div class="wc-balk__totaal"><span>Totaal</span><strong data-wc-balk-bedrag></strong></div>' +
      '<button type="button" class="wc-balk__knop" tabindex="-1">Afrekenen</button>';
    balk.querySelector('button').addEventListener('click', () => {
      const knop = document.querySelector('.cart-page #checkout');
      if (knop) knop.click();
    });
    document.body.appendChild(balk);
  }

  function werkBalkBij() {
    if (!balk) return;
    const bedrag = document.querySelector('.cart-page .wc-totaal__bedrag');
    const doel = balk.querySelector('[data-wc-balk-bedrag]');
    if (bedrag && doel) doel.textContent = bedrag.textContent.trim();
    const knop = document.querySelector('.cart-page #checkout');
    if (waarnemer) waarnemer.disconnect();
    if (!knop) {
      balk.classList.remove('is-zichtbaar');
      return;
    }
    waarnemer = new IntersectionObserver(([ingang]) => {
      const onderKnop = ingang.boundingClientRect.top > window.innerHeight;
      balk.classList.toggle('is-zichtbaar', !ingang.isIntersecting && onderKnop);
    });
    waarnemer.observe(knop);
  }

  /* ---------- Opstarten en na elke wijziging van de winkelwagen ---------- */

  function vernieuw() {
    zetBelofte();
    herstelVinkje();
    bouwBalk();
    werkBalkBij();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vernieuw);
  } else {
    vernieuw();
  }
  document.addEventListener('cart:update', () => setTimeout(vernieuw, 80));
  document.addEventListener('discount:update', () => setTimeout(vernieuw, 80));
  // De lade wordt opnieuw opgebouwd; houd de belofte ook actueel bij openen.
  let gepland = false;
  new MutationObserver(() => {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(() => {
      gepland = false;
      zetBelofte();
      // Nieuw getekende snelle betaalknoppen meteen weer op slot zolang het vinkje uit staat.
      werkSnelleKnoppenBij();
    });
  }).observe(document.body, { childList: true, subtree: true });
  setInterval(zetBelofte, 30000);
})();
